import { createFileRoute } from "@tanstack/react-router";
import Blog from "@/pages/Blog";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/blog/")({
  head: () => routeHead("/blog/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Blog />
  );
}
